import React, { useState } from 'react';
import { getApiBase } from '../../utils/apiBase';

interface VerificacaoProps {
  email: string;
  onVerificar: (codigo: string) => void;
  onCancel: () => void;
}

const Verificacao = ({ email, onVerificar, onCancel }: VerificacaoProps) => {
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const [reenviando, setReenviando] = useState(false);
  const [reenviadoOk, setReenviadoOk] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!codigo.trim()) {
      setError('Por favor, insira o código de verificação');
      return;
    }
    onVerificar(codigo.trim().toUpperCase());
  };

  const handleReenviar = async () => {
    setReenviando(true);
    setReenviadoOk(false);
    setError('');
    try {
      // Gerar novo código no backend e reenviar
      const res = await fetch(`${getApiBase()}/reenviar-verificacao`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.error || 'Erro ao reenviar código');
      }
      setReenviadoOk(true);
      setCodigo('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao reenviar código');
    } finally {
      setReenviando(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50/50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-xl bg-indigo-600 text-white flex items-center justify-center font-bold text-xl mb-4">E</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Verificar E-mail</h1>
          <p className="text-sm text-gray-500">Escalone</p>
        </div>

        <div className="bg-white p-8 rounded-xl border border-gray-200 shadow-sm">
          {error && (
            <div className="p-3 mb-5 text-sm text-red-700 rounded-lg bg-red-50 border border-red-200">
              {error}
            </div>
          )}
          {reenviadoOk && (
            <div className="p-3 mb-5 text-sm text-emerald-700 rounded-lg bg-emerald-50 border border-emerald-200">
              ✅ Novo código enviado! Verifique sua caixa de entrada.
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="text-center space-y-1">
              <p className="text-sm text-gray-600">Enviamos um código de verificação para:</p>
              <p className="text-sm font-semibold text-gray-900">{email}</p>
            </div>

            <div>
              <label htmlFor="codigo" className="block text-sm font-medium text-gray-700 mb-1.5">
                Código de Verificação
              </label>
              <input
                id="codigo"
                type="text"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                maxLength={8}
                autoFocus
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400 outline-none transition-colors tracking-widest text-center font-mono text-lg"
                placeholder="XXXXXX"
              />
            </div>

            <button
              type="submit"
              className="w-full py-2.5 px-4 rounded-lg text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 transition-colors"
            >
              Confirmar conta
            </button>

            <button
              type="button"
              onClick={onCancel}
              className="w-full text-center text-sm text-gray-500 hover:text-gray-900 transition-colors"
            >
              Voltar para o login
            </button>

            <div className="text-center text-sm text-gray-500">
              Não recebeu o código?{' '}
              <button
                type="button"
                onClick={handleReenviar}
                disabled={reenviando}
                className="text-indigo-600 hover:text-indigo-700 font-medium hover:underline disabled:opacity-50"
              >
                {reenviando ? 'Enviando...' : 'Reenviar código'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verificacao;

